import { useContext } from "react";

import { NavigationContainer } from "@react-navigation/native";
//import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { AuthContext } from "../context/AuthContext";
import AuthStack from "./AuthStack";
import AppStack from "./AppStack";
import FirmSelectStack from "../screens/firmselectscreen";
import ChangePasswordStack from "../screens/changepasswordscreen";
import RequestFormStack from "./RequestFormStack";

//const Stack = createNativeStackNavigator();

const AppNav = () => {
  const { userToken, selectFirm, changePassW, userInfo, isCustomerRequest } =
    useContext(AuthContext);

  return (
    <NavigationContainer>
      {isCustomerRequest ? 
        <RequestFormStack />
      :
      userToken !== null ? (
        changePassW ? (
          <ChangePasswordStack />
        ) : selectFirm ? (
          <FirmSelectStack />
        ) : (
          <AppStack />
        )
      ) : (
        <AuthStack />
      )}
    </NavigationContainer>
  );
};

export default AppNav;
